import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import Immutable, { Map } from 'immutable'
import cn from 'classnames'
import { Paper, Typography } from '@material-ui/core'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Collapse from '@material-ui/core/Collapse'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import CircularProgress from '@material-ui/core/CircularProgress'
import Psfs from 'lib/psfs/Psfs'
import PsfsFilter from 'lib/psfs/Filter'
import { MONITORS_AND_ALERTS } from 'constants/appRouting'
import {
  fetchSiteList,
  fetchLocusList,
  setActiveSite,
  setActiveLocus,
  setAnyParamsStore,
} from 'reducers/monitorsAndAlerts/reducer'
import { setProfileMnaFilters } from 'reducers/profile/reducer'
import CircleLoader from 'components/Loading/CircleLoader'
import { isInt } from 'helpers/math'
import { PROFILE_MNA_FILTERS } from 'constants/mnaFilters'
import messages from '../translate'

class LeftSidebar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isHideSidebar: false,
      isOpenLocusList: false,
    }
  }

  componentDidMount() {
    const {
      setProfileMnaFilters,
      history: {
        location: { search },
      },
    } = this.props
    const params = new URLSearchParams(search)
    const site = +params.get('site')
    const locus = +params.get('locus')

    if (site || locus) {
      setProfileMnaFilters({
        ...PROFILE_MNA_FILTERS,
        site: site || null,
        locus: locus || null,
      })
    }
  }

  componentDidUpdate(prevProps) {
    const {
      siteList,
      locusList,
      setAnyParamsStore,
      setProfileMnaFilters,
      selectedSite,
      selectedLocus,
      selectedLocusGroups,
      history: {
        replace,
        location: { search },
      },
    } = this.props

    if (prevProps.siteList !== siteList) {
      if (selectedSite) {
        const sitesArr = siteList.toArray()
        const activeSite = selectedSite
          ? sitesArr.find(({ id }) => id === selectedSite)
          : null
        const isActiveSite = !!activeSite

        this.setState(
          {
            isOpenLocusList: isActiveSite,
          },
          () => {
            setAnyParamsStore({
              activeSite: Map({
                id: isActiveSite ? activeSite.id : 0,
                name: isActiveSite ? activeSite.name : '',
              }),
              includeLevelLower: false,
              showIncludeLevelLowerCheckbox: true,
            })

            if (isActiveSite) {
              this.fetchLocusList(activeSite.id)
            } else {
              setProfileMnaFilters({
                site: null,
                locus: null,
              })
            }
          },
        )
      } else {
        this.setState({
          isOpenLocusList: false,
        })
      }
    }

    if (prevProps.locusList !== locusList && selectedLocus) {
      const locusArr = locusList.toArray()
      const activeLocus = selectedLocus
        ? locusArr.find(({ id }) => id === selectedLocus)
        : null
      const isActiveLocus = !!activeLocus

      if (!isActiveLocus) {
        setProfileMnaFilters({
          locus: null,
        })
      }

      setAnyParamsStore({
        activeLocus: Map({
          id: isActiveLocus ? activeLocus.id : 0,
          containerName: isActiveLocus ? activeLocus.containerName : '',
        }),
        includeLevelLower: !isActiveLocus,
        showIncludeLevelLowerCheckbox: false,
      })

      if (search && search.includes('?')) {
        replace(MONITORS_AND_ALERTS)
      }
    }

    if (
      prevProps.selectedLocusGroups !== selectedLocusGroups &&
      !(
        prevProps.selectedLocusGroups.size === 0 &&
        prevProps.selectedLocusGroups.size === selectedLocusGroups.size
      ) &&
      selectedSite
    ) {
      this.fetchLocusList(selectedSite)
    }
  }

  fetchLocusList(activeSiteId) {
    const { selectedLocusGroups, locusGroupList, fetchLocusList } = this.props
    const psfs = new Psfs()
    psfs.addFilter('site', activeSiteId)
    psfs.addFilter('visibleInUi', 1)

    if (
      locusGroupList.size !== selectedLocusGroups.size &&
      selectedLocusGroups.size
    ) {
      psfs.addFilter(
        'locusGroup',
        selectedLocusGroups.toArray(),
        PsfsFilter.TYPE_IN,
      )
    }

    fetchLocusList({ psfs })
  }

  onLicenseeClick = () => {
    const { licensee, setAnyParamsStore, setProfileMnaFilters } = this.props

    this.setState(
      {
        isOpenLocusList: false,
      },
      () => {
        setProfileMnaFilters({
          site: null,
          locus: null,
        })
        setAnyParamsStore({
          activeLicensee: Map({ id: licensee.id, name: licensee.name }),
          activeSite: Map({ id: 0, name: '' }),
          activeLocus: Map({ id: 0, containerName: '' }),
          locusList: Immutable.List([]),
          includeLevelLower: false,
          showIncludeLevelLowerCheckbox: true,
        })
      },
    )
  }

  onSiteClick = e => {
    const { isOpenLocusList } = this.state
    const {
      siteList,
      selectedSite,
      selectedLocus,
      setAnyParamsStore,
      setProfileMnaFilters,
    } = this.props
    const storeParams = {
      includeLevelLower: false,
      showIncludeLevelLowerCheckbox: true,
    }
    const mnaFilters = {}
    const activeSite = siteList.get(e.currentTarget.dataset.key)

    if (!activeSite) {
      return
    }

    const isSelectedCurrentSite = selectedSite === activeSite.id
    const isShowLocusList =
      !isSelectedCurrentSite || (isSelectedCurrentSite && !isOpenLocusList)

    if (!isSelectedCurrentSite) {
      storeParams.activeSite = Map({ id: activeSite.id, name: activeSite.name })
      storeParams.locusList = Immutable.List([])
      mnaFilters.site = activeSite.id
      this.fetchLocusList(activeSite.id)
    }

    if (selectedLocus) {
      storeParams.activeLocus = Map({ id: 0, containerName: '' })
      mnaFilters.locus = null
    }

    this.setState(
      {
        isOpenLocusList: isShowLocusList,
      },
      () => {
        setProfileMnaFilters(mnaFilters)
        setAnyParamsStore(storeParams)
      },
    )
  }

  onLocusClick = e => {
    const {
      selectedLocus,
      setAnyParamsStore,
      setProfileMnaFilters,
    } = this.props
    const activeLocus = this.props.locusList.get(e.currentTarget.dataset.key)
    const isSelectedCurrentLocus = selectedLocus === activeLocus.id

    if (!activeLocus || isSelectedCurrentLocus) {
      return
    }

    setAnyParamsStore({
      activeLocus: Map({
        id: activeLocus.id,
        containerName: activeLocus.containerName,
      }),
      includeLevelLower: false,
      showIncludeLevelLowerCheckbox: false,
    })

    setProfileMnaFilters({
      locus: activeLocus.id,
    })
  }

  getAlertCounter = value =>
    !isInt(value) ? null : <span className="ma-alert-counter">{value}</span>

  getListIcon = (loading, opening) => {
    if (loading) {
      return <CircularProgress size={20} />
    }

    return opening ? <ExpandLess /> : <ExpandMore />
  }

  getSiteList = () => {
    const { isOpenLocusList } = this.state
    const { isLoadLocusList, selectedSite } = this.props
    const siteList = this.props.siteList.toArray()

    return (
      <List component="div" disablePadding className="ma-site-list">
        {siteList.map(({ id, name, alertCount }, index) => (
          <Fragment key={`${id}-${name}`}>
            <ListItem
              button
              data-key={index}
              onClick={this.onSiteClick}
              className="ma-site-item">
              <ListItemText primary={name} />
              {this.getAlertCounter(alertCount)}
              {this.getListIcon(
                isLoadLocusList && selectedSite === id,
                isOpenLocusList && selectedSite === id,
              )}
            </ListItem>
            {Boolean(isOpenLocusList && selectedSite === id) &&
              this.getLocusList()}
          </Fragment>
        ))}
      </List>
    )
  }

  getLocusList = () => {
    const { isOpenLocusList } = this.state
    const { selectedLocus, locusList } = this.props
    const locusArray = locusList.toArray()

    return (
      <Collapse in={isOpenLocusList} timeout="auto" unmountOnExit>
        <List component="div" disablePadding className="ma-locus-list">
          {locusArray.map(({ id, containerName, alertCount }, index) => (
            <ListItem
              button
              key={`${id}-${containerName}`}
              data-key={index}
              onClick={this.onLocusClick}
              className={cn('ma-locus-item', {
                selected: id === selectedLocus,
              })}>
              <ListItemText primary={containerName} />
              {this.getAlertCounter(alertCount)}
            </ListItem>
          ))}
        </List>
      </Collapse>
    )
  }

  render() {
    const {
      intl: { formatMessage },
      licensee,
      isLoadSiteList,
      isLocusGroupsLoaded,
      siteList,
    } = this.props
    const sites = siteList.toArray()
    const siteListExist = sites && sites.length > 0
    const isLoading = !isLocusGroupsLoaded || isLoadSiteList
    const allSitesAlertsCount = sites.reduce((counter, { alertCount }) => {
      if (alertCount) {
        return counter ? counter + alertCount : alertCount
      }

      return counter
    }, null)

    return (
      <Paper className="ma-left-sidebar">
        {isLoading ? ( // eslint-disable-line no-nested-ternary
          <CircleLoader loading={isLoading} />
        ) : siteListExist ? (
          <List component="nav" className="ma-licensee-list">
            <ListItem
              button
              data-id={licensee.id}
              data-type="licensee"
              onClick={this.onLicenseeClick}>
              <ListItemText primary={formatMessage(messages.allSites)} />
              {this.getAlertCounter(allSitesAlertsCount)}
            </ListItem>
            {this.getSiteList()}
          </List>
        ) : (
          <Typography align="center" className="no-sites" variant="h6">
            {formatMessage(messages.noSites)}
          </Typography>
        )}
      </Paper>
    )
  }
}

export default connect(
  state => ({
    licensee: state.getIn(['profile', 'profile', 'licensee']),
    selectedSite: state.getIn(['profile', 'mnaFilters', 'site']),
    selectedLocus: state.getIn(['profile', 'mnaFilters', 'locus']),
    selectedLocusGroups: state.getIn(['profile', 'mnaFilters', 'locusGroups']),
    siteList: state.getIn(['monitorsAndAlerts', 'siteList']),
    locusList: state.getIn(['monitorsAndAlerts', 'locusList']),
    locusGroupList: state.getIn(['monitorsAndAlerts', 'locusGroupList']),
    isLoadSiteList: state.getIn(['monitorsAndAlerts', 'isLoadSiteList']),
    isLoadLocusList: state.getIn(['monitorsAndAlerts', 'isLoadLocusList']),
    isLocusGroupsLoaded: state.getIn([
      'monitorsAndAlerts',
      'isLocusGroupsLoaded',
    ]),
  }),
  {
    setActiveSite,
    setActiveLocus,
    fetchSiteList,
    fetchLocusList,
    setAnyParamsStore,
    setProfileMnaFilters,
  },
)(withRouter(injectIntl(LeftSidebar)))
